import { Navigate, Outlet, useLocation } from 'react-router'

import { env } from '@/config/env'
import { useAuth } from '@/services/auth/useAuth'

import { ROUTES } from './paths'

export function ProtectedRoute() {
  const { status } = useAuth()
  const location = useLocation()

  if (!env.authEnabled) return <Outlet />
  if (status === 'loading') {
    return <div style={{ padding: 40, color: 'var(--ink-3)' }}>Проверяем сессию…</div>
  }
  if (status === 'anonymous') {
    return <Navigate to={ROUTES.login} replace state={{ from: location.pathname }} />
  }
  return <Outlet />
}
